import { GroupLicense } from '@group/domain';
import { GroupConsoleTitle } from '../common';
import { usePersistedObject } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { GroupLicenseInfo } from './GroupLicenseInfo';
import { LicenseDescriptionPanel } from './LicenseDescriptionPanel';
import { useGroupConsoleOutletContext } from '../WithGroupConsoleMenu';
import { useTranslation } from 'react-i18next';
import { useReleaseToggle } from '@framework/useReleaseToggle';
import {
  CardSubscriptionCheckoutResultNotice,
  getCheckoutResult,
  shouldShowCardSubscriptionCheckoutForm,
} from './CardSubscriptionCheckoutPanel';
import { useSearchParams } from 'react-router';
import { useGroupBillingMethod } from '@group/hooks/useGroupBillingMethod';
import { BillingSupportPanel } from './BillingSupportPanel';

export const GroupConsoleLicensePage: React.FC = () => {
  const { t } = useTranslation();
  const { group } = useGroupConsoleOutletContext();
  const billingMethod = useGroupBillingMethod(group.id);
  const [license] = usePersistedObject(GroupLicense, RTDBPath.Group.groupLicensePath(group.id));
  const isCardSubscriptionCheckoutEnabled = useReleaseToggle('cardSubscriptionCheckout');
  const [searchParams] = useSearchParams();
  const checkoutResult = getCheckoutResult(searchParams.get('checkout'));
  const showCardSubscriptionCheckoutForm = shouldShowCardSubscriptionCheckoutForm(
    license?.type,
    isCardSubscriptionCheckoutEnabled,
    checkoutResult
  );

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <GroupConsoleTitle title={t('group.console.nav.license')} />
      </div>

      {license && <GroupLicenseInfo license={license} />}

      {checkoutResult && <CardSubscriptionCheckoutResultNotice checkoutResult={checkoutResult} />}

      {billingMethod === 'card' && <BillingSupportPanel group={group} />}

      <LicenseDescriptionPanel
        group={group}
        canUseCardCheckout={showCardSubscriptionCheckoutForm}
        isTrial={license?.type === 'trial'}
      />
    </>
  );
};
